var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatOutlined(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 13.5,
    r: 7.5,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.39911 8.3999H15.5991M8.39911 13.1999H12.5991M21.5991 11.9999C21.5991 12.135 21.5963 12.2694 21.5908 12.4031C21.494 14.7461 20.9594 17.1087 21.2911 19.4301L21.3826 20.0708C21.4869 20.8005 20.8185 21.4034 20.1033 21.2246V21.2246C17.9165 20.6779 15.6249 21.1745 13.3943 21.4993C12.9388 21.5656 12.473 21.5999 11.9991 21.5999C6.69718 21.5999 2.39911 17.3018 2.39911 11.9999C2.39911 6.69797 6.69718 2.3999 11.9991 2.3999C17.301 2.3999 21.5991 6.69797 21.5991 11.9999Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatOutlined);
export default __webpack_public_path__ + "static/media/chat_outlined.5a5085a0fa7e2ec2c0d64bebafec5719.svg";
export { ForwardRef as ReactComponent };